import { QIcon_hint_black, QIcon_underline_black } from '@repo/icons/index'
import { useState } from 'react'
import ReactHtmlParser from 'react-html-parser'
import { GrammarCompItem, HIGHLIGHT_METRIC } from '../../../../model/caf.interface'
import useIsMobile from '../../../../modules/hooks/common/useIsMobile'
import useHtmlParserTransform from '../../../../modules/hooks/webview/caf/common/useHtmlParserTransform'
import useRNMsg, { ringleAppNavs } from '../../../../modules/hooks/webview/common/useRNMsg'
import { n_caf } from '../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../modules/i18n/useTranslation'
import {
  ICON_ALARM_GRAY,
  ICON_CHECK_CIRCLE_GREEN_2,
  ICON_CHEVRON_DOWN_GRAY700,
  ICON_CHEVRON_UP_GRAY700,
} from '../../../../modules/svg/svg'
import ErrorReportPopupComponent from '../../../student/portal/lessons/caf/CAFOverview/popup/CafErrorReportPopup'
import Accordion from '../common/Accordion'
import AudioController from '../common/AudioController'
import AccordionContainer from './AccordionContainer'
import AccordionTitle from './AccordionTitle'

const HighlightDetailListCorrection = ({ details, tag }) => {
  const { t } = useTranslation()
  const { sendPostMsg } = useRNMsg()
  const { transformHTMLNode } = useHtmlParserTransform()
  const [sentenceToReport, setSentenceToReport] = useState('')
  const isMobile = useIsMobile()
  const [showPopup, setShowPopup] = useState(false)
  const [reportId, setReportId] = useState(0)

  const handleClickErrorReport = (hilightId, content) => () => {
    setReportId(hilightId)
    if (isMobile) {
      sendPostMsg({
        nav: ringleAppNavs.cafErrorReport,
        detail_id: hilightId,
        detail_content: content,
        from: 'highlight',
      })
    } else {
      setSentenceToReport(content)
      setShowPopup(true)
    }
  }

  const [errIndex, setErrIndex] = useState(1)
  const handleIndex = (len) => () => {
    setErrIndex((prev) => (prev > 1 ? 1 : len))
  }
  // const initIndex = () => {
  //   setErrIndex(1)
  // }

  console.log(details, 'details')
  if (!details) return <></>
  return (
    <div className="mb-[12px]">
      <AccordionContainer>
        {details?.map((compItem: GrammarCompItem, idx) => (
          <Accordion
            key={idx + 'grammar_compItem'}
            title={<AccordionTitle type={HIGHLIGHT_METRIC.GRAMMAR} content={compItem} index={idx + 1} tag={tag} />}
            className="mb-[12px]"
            idx={idx}
          >
            <article className="mb-[8px]">
              <div className="flex">
                <img src={ICON_CHECK_CIRCLE_GREEN_2} alt="check" className="h-20 w-20" />
                <span className="text-medium ml-[10px] text-[14px] font-medium">
                  {ReactHtmlParser(compItem.correct_sentence, { transform: transformHTMLNode })}
                </span>
              </div>
              {compItem.errors?.length > 0 ? (
                <p className="text-sBody my-[16px] rounded bg-gray-50 p-[8px] text-[14px] ">
                  <div>
                    {compItem.errors?.slice(0, errIndex).map((item: any, index: number) => (
                      <div className="mb-8" key={index}>
                        <div className="mb-8 flex items-center">
                          <QIcon_hint_black className="mr-[8px]" />
                          <span className="text-h5 mb-[4px] h-12 gap-[4px] font-medium text-black">{item.title}</span>
                        </div>
                        <span key={index} className="text-sBody mb-4  block">
                          {item.body}
                        </span>
                      </div>
                    ))}
                  </div>
                  {compItem.errors?.length > 1 && errIndex > 1 && (
                    <div className="mb-[16px] flex-row">
                      <QIcon_underline_black width={24} height={24} className="inline" />
                      <span className="text-sm text-gray-600">{t(n_caf.accuracy.underline_text)}</span>
                    </div>
                  )}
                  {compItem.errors?.length > 1 && (
                    <div className="flex items-center">
                      {errIndex === 1 ? (
                        <>
                          <div className="mr-4" onClick={handleIndex(compItem.errors?.length)}>
                            {t(n_caf.accuracy.other_errors(compItem.errors?.length - 1))}
                          </div>
                          <img src={ICON_CHEVRON_DOWN_GRAY700} width={10} height={5} alt="down" className="mb-4" />
                        </>
                      ) : (
                        <>
                          <div className="mr-4" onClick={handleIndex(compItem.errors?.length)}>
                            {t(n_caf.accuracy.collapse)}
                          </div>
                          <img src={ICON_CHEVRON_UP_GRAY700} width={12} height={5} alt="up" className="mb-4" />
                        </>
                      )}
                    </div>
                  )}
                </p>
              ) : (
                <div className="h-[12px]" />
              )}
              {compItem.audio_url && <AudioController src={compItem.audio_url} id={idx} />}
            </article>
            <div
              className="flex cursor-pointer items-center text-[12px] font-medium text-gray-500 sm:text-[14px]"
              onClick={handleClickErrorReport(compItem.id, compItem?.sentence || compItem?.my_sentence)}
            >
              <img src={ICON_ALARM_GRAY} alt="alarm" className="mb-4" />
              <div className="ml-2 mt-1">{t(n_caf.highlight.report)}</div>
            </div>
          </Accordion>
        ))}
        <ErrorReportPopupComponent
          content={sentenceToReport}
          type="highlight"
          isShowEditPopup={showPopup}
          setShowEditPopup={setShowPopup}
          id={reportId}
        />
      </AccordionContainer>
    </div>
  )
}

export default HighlightDetailListCorrection
